export const config_kayC = {
  "title": "", //"Design Your Own Fashion Jewelry",
  "max_view": 3,
  "view_image_base": "//bridalimages.thepersonalizedbest.com/bridal_imageFJC/",
  "options_all": [
      "type", "sh", "ds",  "cec", "cec2", "headc", "rsetc", "hmet", "rmet","dctw", "rs", "bl", "cross1", "rs2", "cross2", "cross3", "bl2"
  ],
  "options_type": {
    "image_base": "type",
    "name": "Jewelry Type",
    "show": true,
    "option_name": "type",
    "css": "type",
    "type": "control",
    "image_postfix": "",
    "options": [
      {"image": "0.jpg", "name": "None", "value": "0", "show": false, "effect": [{ "effect_attr": "show", "optionSet": ["sh"], "effect_value": false }, { "effect_attr": "show", "optionSet": ["ds"], "effect_value": false }, { "effect_attr": "show", "optionSet": ["dctw"], "effect_value": false }, { "effect_attr": "show", "optionSet": ["cec"], "effect_value": false }, { "effect_attr": "show", "optionSet": ["cec2"], "effect_value": false }, { "effect_attr": "show", "optionSet": ["headc"], "effect_value": false }, { "effect_attr": "show", "optionSet": ["rsetc"], "effect_value": false }, { "effect_attr": "show", "optionSet": ["rs"], "effect_value": false }, { "effect_attr": "show", "optionSet": ["bl"], "effect_value": false }, { "effect_attr": "show", "optionSet": ["hmet"], "effect_value": false }, { "effect_attr": "show", "optionSet": ["rmet"], "effect_value": false }, { "effect_attr": "show", "optionSet": ["cross1"], "effect_value": false }, { "effect_attr": "show", "optionSet": ["cross2"], "effect_value": false }, { "effect_attr": "show", "optionSet": ["cross3"], "effect_value": false } ]},
      {"image": "r3.jpg", "name": "Ring", "value": "R", "effect": [{ "effect_attr": "show", "optionSet": ["sh"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["ds"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["dctw"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["cec"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["cec2"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["headc"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["rsetc"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["rs"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["bl"], "effect_value": false }, { "effect_attr": "show", "optionSet": ["hmet"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["rmet"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["cross1"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["cross2"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["cross3"], "effect_value": true } ]},
      {"image": "p1.jpg", "name": "Pendant", "value": "P", "effect": [{ "effect_attr": "show", "optionSet": ["sh"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["ds"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["dctw"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["cec"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["cec2"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["headc"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["rsetc"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["rs"], "effect_value": false }, { "effect_attr": "show", "optionSet": ["bl"], "effect_value": false }, { "effect_attr": "show", "optionSet": ["hmet"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["rmet"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["cross1"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["cross2"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["cross3"], "effect_value": true } ]},
      {"image": "e1.jpg", "name": "Earrings", "value": "E", "effect": [{ "effect_attr": "show", "optionSet": ["sh"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["ds"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["dctw"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["cec"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["cec2"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["headc"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["rsetc"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["rs"], "effect_value": false }, { "effect_attr": "show", "optionSet": ["bl"], "effect_value": false }, { "effect_attr": "show", "optionSet": ["hmet"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["rmet"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["cross1"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["cross2"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["cross3"], "effect_value": true } ]},
      {"image": "b1.jpg", "name": "Bracelet", "value": "B", "effect": [{ "effect_attr": "show", "optionSet": ["sh"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["ds"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["dctw"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["cec"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["cec2"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["headc"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["rsetc"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["rs"], "effect_value": false }, { "effect_attr": "show", "optionSet": ["bl"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["hmet"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["rmet"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["cross1"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["cross2"], "effect_value": true }, { "effect_attr": "show", "optionSet": ["cross3"], "effect_value": true } ]}
    ]
  },
  "options_sh": {
      "image_base": "style",
      "name": "Style",
      "show": false,
      "option_name": "sh",
      "type": "control",
      "css": "sh",
      "image_postfix": "",
      "options": [
        {"image": "r3.jpg", "name": "", "value": "R3", "effect": [
              {"effect_attr": "show", "optionSet": ["headc"], "effect_value": true},
              {"effect_attr": "show", "optionSet": ["rsetc"], "effect_value": true},
              {"effect_attr": "show", "optionSet": ["hmet"], "effect_value": true},
              {"effect_attr": "show", "optionSet": ["cec2"], "effect_value": false},
              {"effect_attr": "show", "optionSet": ["ds"], "option": ["HPS"], "effect_value": true},
              {"effect_attr": "show", "optionSet": ["ds"], "option": ["HECU"], "effect_value": true}]},
         {"image": "r2.jpg", "name": "", "value": "R2", "effect": [
                  {"effect_attr": "show", "optionSet": ["headc"], "effect_value": false},
                  {"effect_attr": "show", "optionSet": ["rsetc"], "effect_value": true},
                  {"effect_attr": "show", "optionSet": ["hmet"], "effect_value": true},
                  {"effect_attr": "show", "optionSet": ["cec2"], "effect_value": false},
                  {"effect_attr": "show", "optionSet": ["ds"], "option": ["HPS"], "effect_value": true},
                  {"effect_attr": "show", "optionSet": ["ds"], "option": ["HECU"], "effect_value": true}]},
         {"image": "r1.jpg", "name": "", "value": "R1", "effect": [
                    {"effect_attr": "show", "optionSet": ["cec2"], "effect_value": false},
                    {"effect_attr": "show", "optionSet": ["ds"], "option": ["HPS"], "effect_value": true},
                    {"effect_attr": "show", "optionSet": ["ds"], "option": ["HECU"], "effect_value": true}]},
{"image": "r12.jpg", "name": "", "value": "R12", "effect": [
                        {"effect_attr": "show", "optionSet": ["headc"], "effect_value": true},
                        {"effect_attr": "show", "optionSet": ["rsetc"], "effect_value": true},
                        {"effect_attr": "show", "optionSet": ["hmet"], "effect_value": true},
                        {"effect_attr": "show", "optionSet": ["cec2"], "effect_value": false},
                        {"effect_attr": "show", "optionSet": ["ds"], "option": ["HPS"], "effect_value": true},
                        {"effect_attr": "show", "optionSet": ["ds"], "option": ["HECU"], "effect_value": true}]},
    {"image": "r6.jpg", "name": "", "value": "R6", "effect": [
                          {"effect_attr": "show", "optionSet": ["headc"], "effect_value": true},
                          {"effect_attr": "show", "optionSet": ["rsetc"], "effect_value": true},
                          {"effect_attr": "show", "optionSet": ["hmet"], "effect_value": true},
                          {"effect_attr": "show", "optionSet": ["cec2"], "effect_value": false},
                          {"effect_attr": "show", "optionSet": ["ds"], "option": ["HPS"], "effect_value": true},
                          {"effect_attr": "show", "optionSet": ["ds"], "option": ["HECU"], "effect_value": true}]},
        {"image": "r4.jpg", "name": "", "value": "R4", "effect": [
                            {"effect_attr": "show", "optionSet": ["headc"], "effect_value": true},
                            {"effect_attr": "show", "optionSet": ["rsetc"], "effect_value": true},
                            {"effect_attr": "show", "optionSet": ["hmet"], "effect_value": true},
                            {"effect_attr": "show", "optionSet": ["cec2"], "effect_value": false},
                            {"effect_attr": "show", "optionSet": ["ds"], "option": ["HPS"], "effect_value": true},
                            {"effect_attr": "show", "optionSet": ["ds"], "option": ["HECU"], "effect_value": true}]},
        {"image": "r9.jpg", "name": "", "value": "R9", "effect": [
                                    {"effect_attr": "show", "optionSet": ["headc"], "effect_value": true},
                                    {"effect_attr": "show", "optionSet": ["rsetc"], "effect_value": false},
                                    {"effect_attr": "show", "optionSet": ["hmet"], "effect_value": true},
                                    {"effect_attr": "show", "optionSet": ["cec2"], "effect_value": false},
                                    {"effect_attr": "show", "optionSet": ["ds"], "option": ["HPS"], "effect_value": true},
                                    {"effect_attr": "show", "optionSet": ["ds"], "option": ["HECU"], "effect_value": true}]},
                                            
          {"image": "p1.jpg", "name": "", "value": "P1", "effect": [
              {"effect_attr": "show", "optionSet": ["headc"], "effect_value": true},
              {"effect_attr": "show", "optionSet": ["rsetc"], "effect_value": false},
              {"effect_attr": "show", "optionSet": ["hmet"], "effect_value": false},
              {"effect_attr": "show", "optionSet": ["cec2"], "effect_value": false},
              {"effect_attr": "show", "optionSet": ["ds"], "option": ["HPS"], "effect_value": true},
              {"effect_attr": "show", "optionSet": ["ds"], "option": ["HECU"], "effect_value": true}]},
        {"image": "p2.jpg", "name": "", "value": "P2", "effect": [
              {"effect_attr": "show", "optionSet": ["headc"], "effect_value": true},
              {"effect_attr": "show", "optionSet": ["rsetc"], "effect_value": false},
              {"effect_attr": "show", "optionSet": ["hmet"], "effect_value": false},
              {"effect_attr": "show", "optionSet": ["cec2"], "effect_value": false},
              {"effect_attr": "show", "optionSet": ["ds"], "option": ["HPS"], "effect_value": true},
              {"effect_attr": "show", "optionSet": ["ds"], "option": ["HECU"], "effect_value": true}]},
              {"image": "p5.jpg", "name": "", "value": "P5", "effect": [
                {"effect_attr": "show", "optionSet": ["headc"], "effect_value": true},
                {"effect_attr": "show", "optionSet": ["rsetc"], "effect_value": true},
                {"effect_attr": "show", "optionSet": ["hmet"], "effect_value": false},
                {"effect_attr": "show", "optionSet": ["cec2"], "effect_value": false},
                {"effect_attr": "show", "optionSet": ["ds"], "option": ["HPS"], "effect_value": true},
                {"effect_attr": "show", "optionSet": ["ds"], "option": ["HECU"], "effect_value": true}]},
          {"image": "p9.jpg", "name": "", "value": "P9", "effect": [
                  {"effect_attr": "show", "optionSet": ["headc"], "effect_value": true},
                  {"effect_attr": "show", "optionSet": ["rsetc"], "effect_value": true},
                  {"effect_attr": "show", "optionSet": ["hmet"], "effect_value": false},
                  {"effect_attr": "show", "optionSet": ["cec2"], "effect_value": false},
                  {"effect_attr": "show", "optionSet": ["ds"], "option": ["HPS"], "effect_value": true},
                  {"effect_attr": "show", "optionSet": ["ds"], "option": ["HECU"], "effect_value": true}      ]} ,
     {"image": "r5.jpg", "name": "", "value": "R5", "effect": [
              {"effect_attr": "show", "optionSet": ["headc"], "effect_value": true},
              {"effect_attr": "show", "optionSet": ["rsetc"], "effect_value": true},
              {"effect_attr": "show", "optionSet": ["hmet"], "effect_value": true},
              {"effect_attr": "show", "optionSet": ["cec2"], "effect_value": false},
              {"effect_attr": "show", "optionSet": ["ds"], "option": ["HPS"], "effect_value": true},
              {"effect_attr": "show", "optionSet": ["ds"], "option": ["HECU"], "effect_value": true}]},
      
        {"image": "p6.jpg", "name": "", "value": "P6", "effect": [
              {"effect_attr": "show", "optionSet": ["headc"], "effect_value": true},
              {"effect_attr": "show", "optionSet": ["rsetc"], "effect_value": false},
              {"effect_attr": "show", "optionSet": ["hmet"], "effect_value": false},
              {"effect_attr": "show", "optionSet": ["cec2"], "effect_value": false},
              {"effect_attr": "show", "optionSet": ["ds"], "option": ["HPS"], "effect_value": true},
              {"effect_attr": "show", "optionSet": ["ds"], "option": ["HECU"], "effect_value": true}]},
       {"image": "p3.jpg", "name": "", "value": "P3", "effect": [
                {"effect_attr": "show", "optionSet": ["headc"], "effect_value": true},
                {"effect_attr": "show", "optionSet": ["rsetc"], "effect_value": false},
                {"effect_attr": "show", "optionSet": ["hmet"], "effect_value": false},
                {"effect_attr": "show", "optionSet": ["cec2"], "effect_value": false},
                {"effect_attr": "show", "optionSet": ["ds"], "option": ["HPS"], "effect_value": true},
                {"effect_attr": "show", "optionSet": ["ds"], "option": ["HECU"], "effect_value": true}]},
         {"image": "p7.jpg", "name": "", "value": "P7", "effect": [
              {"effect_attr": "show", "optionSet": ["headc"], "effect_value": true},
              {"effect_attr": "show", "optionSet": ["rsetc"], "effect_value": false},
              {"effect_attr": "show", "optionSet": ["hmet"], "effect_value": false},
              {"effect_attr": "show", "optionSet": ["cec2"], "effect_value": false},
              {"effect_attr": "show", "optionSet": ["ds"], "option": ["HPS"], "effect_value": true},
              {"effect_attr": "show", "optionSet": ["ds"], "option": ["HECU"], "effect_value": true}]},
       
       //--------------------------------------------------------------------B
       
              {"image": "b1.jpg", "name": "", "value": "B1", "effect": [
                  {"effect_attr": "show", "optionSet": ["headc"], "effect_value": true},
                  {"effect_attr": "show", "optionSet": ["rsetc"], "effect_value": false},
                  {"effect_attr": "show", "optionSet": ["hmet"], "effect_value": false},
                  {"effect_attr": "show", "optionSet": ["cec2"], "effect_value": false},
                  {"effect_attr": "show", "optionSet": ["ds"], "option": ["HPS"], "effect_value": true},
                  {"effect_attr": "show", "optionSet": ["ds"], "option": ["HECU"], "effect_value": true}]},
              {"image": "b3.jpg", "name": "", "value": "B3", "effect": [
                        {"effect_attr": "show", "optionSet": ["headc"], "effect_value": true},
                        {"effect_attr": "show", "optionSet": ["rsetc"], "effect_value": false},
                        {"effect_attr": "show", "optionSet": ["hmet"], "effect_value": false},
                        {"effect_attr": "show", "optionSet": ["cec2"], "effect_value": false},
                        { "effect_attr": "show", "optionSet": ["bl"], "effect_value": false },
                        {"effect_attr": "show", "optionSet": ["ds"], "option": ["HPS"], "effect_value": true},
                        {"effect_attr": "show", "optionSet": ["ds"], "option": ["HECU"], "effect_value": true}]},
            {"image": "b2.jpg", "name": "", "value": "B2", "effect": [
                  {"effect_attr": "show", "optionSet": ["headc"], "effect_value": false},
                  {"effect_attr": "show", "optionSet": ["rsetc"], "effect_value": false},
                  {"effect_attr": "show", "optionSet": ["hmet"], "effect_value": false},
                  {"effect_attr": "show", "optionSet": ["cec2"], "effect_value": true},
                  {"effect_attr": "show", "optionSet": ["ds"], "option": ["HPS"], "effect_value": true},
                  {"effect_attr": "show", "optionSet": ["ds"], "option": ["HECU"], "effect_value": true}]},
             {"image": "b4.jpg", "name": "", "value": "B4", "effect": [
                  {"effect_attr": "show", "optionSet": ["headc"], "effect_value": true},
                  {"effect_attr": "show", "optionSet": ["rsetc"], "effect_value": false},
                  {"effect_attr": "show", "optionSet": ["hmet"], "effect_value": false},
                  {"effect_attr": "show", "optionSet": ["cec2"], "effect_value": false},
                  {"effect_attr": "show", "optionSet": ["ds"], "option": ["HPS"], "effect_value": false},
                  {"effect_attr": "show", "optionSet": ["ds"], "option": ["HECU"], "effect_value": true}]},

///-------------------------------------------------------------------------

{"image": "e1.jpg", "name": "", "value": "E1", "effect": [
      {"effect_attr": "show", "optionSet": ["headc"], "effect_value": true},
      {"effect_attr": "show", "optionSet": ["rsetc"], "effect_value": false},
      {"effect_attr": "show", "optionSet": ["hmet"], "effect_value": false},
      {"effect_attr": "show", "optionSet": ["cec2"], "effect_value": false},
      {"effect_attr": "show", "optionSet": ["ds"], "option": ["HPS"], "effect_value": true},
      {"effect_attr": "show", "optionSet": ["ds"], "option": ["HECU"], "effect_value": true}]},
{"image": "e6.jpg", "name": "", "value": "E6", "effect": [
            {"effect_attr": "show", "optionSet": ["headc"], "effect_value": true},
            {"effect_attr": "show", "optionSet": ["rsetc"], "effect_value": false},
            {"effect_attr": "show", "optionSet": ["hmet"], "effect_value": false},
            {"effect_attr": "show", "optionSet": ["cec2"], "effect_value": false},
            {"effect_attr": "show", "optionSet": ["ds"], "option": ["HPS"], "effect_value": true},
            {"effect_attr": "show", "optionSet": ["ds"], "option": ["HECU"], "effect_value": true}]},
  {"image": "e7.jpg", "name": "", "value": "E7", "effect": [
                  {"effect_attr": "show", "optionSet": ["headc"], "effect_value": true},
                  {"effect_attr": "show", "optionSet": ["rsetc"], "effect_value": false},
                  {"effect_attr": "show", "optionSet": ["hmet"], "effect_value": false},
                  {"effect_attr": "show", "optionSet": ["cec2"], "effect_value": false},
                  {"effect_attr": "show", "optionSet": ["ds"], "option": ["HPS"], "effect_value": true},
                  {"effect_attr": "show", "optionSet": ["ds"], "option": ["HECU"], "effect_value": true}]},

{"image": "e2.jpg", "name": "", "value": "E2", "effect": [
      {"effect_attr": "show", "optionSet": ["headc"], "effect_value": true},
      {"effect_attr": "show", "optionSet": ["rsetc"], "effect_value": true},
      {"effect_attr": "show", "optionSet": ["hmet"], "effect_value": false},
      {"effect_attr": "show", "optionSet": ["cec2"], "effect_value": false},
      {"effect_attr": "show", "optionSet": ["ds"], "option": ["HPS"], "effect_value": true},
      {"effect_attr": "show", "optionSet": ["ds"], "option": ["HECU"], "effect_value": true}]},
{"image": "e5.jpg", "name": "", "value": "E5", "effect": [
      {"effect_attr": "show", "optionSet": ["headc"], "effect_value": true},
      {"effect_attr": "show", "optionSet": ["rsetc"], "effect_value": false},
      {"effect_attr": "show", "optionSet": ["hmet"], "effect_value": false},
      {"effect_attr": "show", "optionSet": ["cec2"], "effect_value": false},
      {"effect_attr": "show", "optionSet": ["ds"], "option": ["HPS"], "effect_value": true},
      {"effect_attr": "show", "optionSet": ["ds"], "option": ["HECU"], "effect_value": true}]},
 {"image": "e3.jpg", "name": "", "value": "E3", "effect": [
        {"effect_attr": "show", "optionSet": ["headc"], "effect_value": true},
        {"effect_attr": "show", "optionSet": ["rsetc"], "effect_value": false},
        {"effect_attr": "show", "optionSet": ["hmet"], "effect_value": false},
        {"effect_attr": "show", "optionSet": ["cec2"], "effect_value": false},
        {"effect_attr": "show", "optionSet": ["ds"], "option": ["HPS"], "effect_value": true},
        {"effect_attr": "show", "optionSet": ["ds"], "option": ["HECU"], "effect_value": true}]},
                        


{"image": "e8.jpg", "name": "", "value": "E8", "effect": [
              {"effect_attr": "show", "optionSet": ["headc"], "effect_value": true},
              {"effect_attr": "show", "optionSet": ["rsetc"], "effect_value": false},
              {"effect_attr": "show", "optionSet": ["hmet"], "effect_value": false},
              {"effect_attr": "show", "optionSet": ["cec2"], "effect_value": false},
              {"effect_attr": "show", "optionSet": ["ds"], "option": ["HPS"], "effect_value": true},
              {"effect_attr": "show", "optionSet": ["ds"], "option": ["HECU"], "effect_value": true}]},
     
    //----------------------------------------------------------------------------------
    
    {"image": "r7.jpg", "name": "", "value": "R7", "effect": [
      {"effect_attr": "show", "optionSet": ["headc"], "effect_value": true},
      {"effect_attr": "show", "optionSet": ["rsetc"], "effect_value": false},
      {"effect_attr": "show", "optionSet": ["hmet"], "effect_value": true},
      {"effect_attr": "show", "optionSet": ["cec2"], "effect_value": false},
      {"effect_attr": "show", "optionSet": ["ds"], "option": ["HPS"], "effect_value": true},
      {"effect_attr": "show", "optionSet": ["ds"], "option": ["HECU"], "effect_value": true}]},
{"image": "r10.jpg", "name": "", "value": "R10", "effect": [
                  {"effect_attr": "show", "optionSet": ["headc"], "effect_value": false},
                  {"effect_attr": "show", "optionSet": ["rsetc"], "effect_value": true},
                  {"effect_attr": "show", "optionSet": ["hmet"], "effect_value": true},
                  {"effect_attr": "show", "optionSet": ["cec2"], "effect_value": false},
                  {"effect_attr": "show", "optionSet": ["ds"], "option": ["HPS"], "effect_value": true},
                  {"effect_attr": "show", "optionSet": ["ds"], "option": ["HECU"], "effect_value": true}]},
        {"image": "r11.jpg", "name": "", "value": "R11", "effect": [
                  {"effect_attr": "show", "optionSet": ["headc"], "effect_value": false},
                  {"effect_attr": "show", "optionSet": ["rsetc"], "effect_value": true},
                  {"effect_attr": "show", "optionSet": ["hmet"], "effect_value": true},
                  {"effect_attr": "show", "optionSet": ["cec2"], "effect_value": false},
                  {"effect_attr": "show", "optionSet": ["ds"], "option": ["HPS"], "effect_value": true},
                  {"effect_attr": "show", "optionSet": ["ds"], "option": ["HECU"], "effect_value": true}]},
        {"image": "p8.jpg", "name": "", "value": "P8", "effect": [
              {"effect_attr": "show", "optionSet": ["headc"], "effect_value": true},
              {"effect_attr": "show", "optionSet": ["rsetc"], "effect_value": true},
              {"effect_attr": "show", "optionSet": ["hmet"], "effect_value": false},
              {"effect_attr": "show", "optionSet": ["cec2"], "effect_value": false},
              {"effect_attr": "show", "optionSet": ["ds"], "option": ["HPS"], "effect_value": true},
              {"effect_attr": "show", "optionSet": ["ds"], "option": ["HECU"], "effect_value": false}]}          ,
       
      ]
  },
  "options_cec": {
      "image_base": "stones6",
      "name": "Center Stone Color",
      "show": false,
      "option_name": "cec",
      "type": "control",
      "css": "cec",
      "image_postfix": "ds",
      "options": [
       // {"value": "0", "show": false},
       {"image": "LBT.jpg", "quality": "", "name": "London Blue Topaz", "value": "LBT"},
       {"image": "SBT.jpg", "quality": "", "name": "Swiss Blue Topaz", "value": "0"},
       {"image": "WT.jpg", "quality": "", "name": "White Topaz", "value": "WT"},
         {"image": "AQ.jpg", "quality": "", "name": "Aquamarine", "value": "AQ"},
         {"image": "AM.jpg", "quality": "", "name": "Amethyst", "value": "AM"},
         {"image": "PZ.jpg", "quality": "", "name": "Peridot", "value": "PZ"},
         {"image": "CT.jpg", "quality": "", "name": "Citrine", "value": "CT"},
        /* {"image": "MG.jpg", "quality": "", "name": "Morganite", "value": "MG"}, */
        {"image": "TZ.jpg", "quality": "", "name": "Tanzanite", "value": "TZ"},
        {"image": "PT.jpg", "quality": "", "name": "Pink Tourmaline", "value": "PT"},
        {"image": "RH.jpg", "quality": "", "name": "Rhodolite", "value": "RH"}
      ]
  },
  "options_cec2": {
      "image_base": "stones6",
      "name": "Stone Color 2",
      "show": false,
      "option_name": "cec2",
      "type": "control",
      "css": "cec",
      "image_postfix": "ds",
      "options": [
     //   {"value": "0", "show": false},
     {"image": "LBT.jpg", "quality": "", "name": "Blue Topaz", "value": "LBT"},
     {"image": "SBT.jpg", "quality": "", "name": "Swiss Blue Topaz", "value": "0"},
     {"image": "WT.jpg", "quality": "", "name": "White Topaz", "value": "WT"},
       {"image": "AQ.jpg", "quality": "", "name": "Aquamarine", "value": "AQ"},
       {"image": "AM.jpg", "quality": "", "name": "Amethyst", "value": "AM"},
       {"image": "PZ.jpg", "quality": "", "name": "Peridot", "value": "PZ"},
       {"image": "CT.jpg", "quality": "", "name": "Citrine", "value": "CT"},
      /* {"image": "MG.jpg", "quality": "", "name": "Morganite", "value": "MG"}, */
      {"image": "TZ.jpg", "quality": "", "name": "Tanzanite", "value": "TZ"},
      {"image": "PT.jpg", "quality": "", "name": "Pink Tourmaline", "value": "PT"},
      {"image": "RH.jpg", "quality": "", "name": "Rhodolite", "value": "RH"}
      ]
  },
  "options_ds": {
      "image_base": "shape",
      "name": "Center Stone Shape",
      "show": false,
      "option_name": "ds",
      "css": "ds",
      "type": "control",
      "image_postfix": "",
      "options": [
            {"image": "HPS.jpg", "name": "Pear", "value": "HPS", "effect": []},
            {"image": "HCU.jpg", "name": "Cushion", "value": "HCU", "effect": []},
            {"image": "HOV.jpg", "name": "Oval", "value": "HOV", "effect": []},
            {"image": "HRD.jpg", "name": "Round", "value": "HRD", "effect": []},
            {"image": "HECU.jpg", "name": "Elongated Cushion", "value": "HECU", "effect": []}
        ]
  },
  "options_dctw": {
      "image_base": "ctw",
      "name": "Center Stone Size",
      "show": false,
      "option_name": "dctw",
      "type": "control",
      "css": "ctw",
      "image_postfix": "",
      "options": [
        {"image": "1.jpg", "name": "7 MM.", "name2": "8x6 MM.", "name3": "6 MM.", "name4": "7x5 MM.", "name5": "8x6 MM.", "name6": "7x5 MM.", "name7": "5 MM.", "name8": "6x4 MM.", "value": "1", "effect": []},
        {"image": "2.jpg", "name": "8 MM.", "name2": "9x7 MM.", "name3": "7 MM.", "name4": "8x6 MM.", "name5": "9x6 MM.", "name6": "8x6 MM.", "name7": "6 MM.", "name8": "7x5 MM.", "value": "2", "effect": []},
        {"image": "3.jpg", "name": "9 MM.", "name2": "10x8 MM.", "name3": "8 MM.", "name4": "9x7 MM.", "name5": "10x7 MM.", "name6": "9x6 MM.", "name7": "7 MM.", "name8": "8x6 MM.", "value": "3", "effect": []}
      ]
  },
  "options_headc": {
      "image_base": "stones6",
      "name": "Accent Color 1",
      "show": false,
      "option_name": "headc",
      "css": "singlestone",
      "type": "select",
      "image_postfix": "",
      "options": [
        {"image": "WT.jpg", "quality": "", "name": "White Topaz", "value": "WT"},
        {"image": "AM.jpg", "quality": "", "name": "Amethyst", "value": "AM"},
        {"image": "GA.jpg", "quality": "", "name": "Garnet", "value": "GA"},
        {"image": "WS.jpg", "quality": "", "name": "Diamond", "value": "D"},
        {"image": "PZ.jpg", "quality": "", "name": "Peridot", "value": "PZ"},
        {"image": "CT.jpg", "quality": "", "name": "Citrine", "value": "CT"},
        {"image": "PT.jpg", "quality": "", "name": "Pink Tourmaline", "value": "PT"},
        {"image": "EM.jpg", "quality": "", "name": "Emerald", "value": "EM"},
        {"image": "SAP.jpg", "quality": "", "name": "Sapphire", "value": "SAP"},
        {"image": "RU.jpg", "quality": "", "name": "Ruby", "value": "RU"},
        {"image": "LBT.jpg", "quality": "", "name": "Blue Topaz", "value": "LBT"},
        {"image": "TZ.jpg", "quality": "", "name": "Tanzanite", "value": "TZ"},
        {"image": "AQ.jpg", "quality": "", "name": "Aquamarine", "value": "AQ"},
      ]
  },
  "options_rsetc": {
      "image_base": "stones6",
      "name": "Accent Color 2",
      "show": false,
      "attr": "rsetc",
      "css": "shankgems",
      "option_name": "rsetc",
      "type": "control",
      "image_postfix": "",
      "options": [
     {"image": "WT.jpg", "quality": "", "name": "White Topaz", "value": "WT"},
     {"image": "AM.jpg", "quality": "", "name": "Amethyst", "value": "AM"},
     {"image": "GA.jpg", "quality": "", "name": "Garnet", "value": "GA"},
     {"image": "WS.jpg", "quality": "", "name": "Diamond", "value": "D"},
     {"image": "PZ.jpg", "quality": "", "name": "Peridot", "value": "PZ"},
     {"image": "CT.jpg", "quality": "", "name": "Citrine", "value": "CT"},
     {"image": "PT.jpg", "quality": "", "name": "Pink Tourmaline", "value": "PT"},
     {"image": "EM.jpg", "quality": "", "name": "Emerald", "value": "EM"},
     {"image": "SAP.jpg", "quality": "", "name": "Sapphire", "value": "SAP"},
     {"image": "RU.jpg", "quality": "", "name": "Ruby", "value": "RU"},
     {"image": "LBT.jpg", "quality": "", "name": "Blue Topaz", "value": "LBT"},
     {"image": "TZ.jpg", "quality": "", "name": "Tanzanite", "value": "TZ"},
     {"image": "AQ.jpg", "quality": "", "name": "Aquamarine", "value": "AQ"},
   ]
  },
  "options_rs": {
      "image_base": "rs",
      "name": "Ring Size",
      "show": false,
      "option_name": "rs",
      "type": "select",
      "css": "rs",
      "image_postfix": "",
      "options": [
        {"value": "0", "show": false},
        {"image": "4.jpg", "name": "", "value": "4"},
        {"image": "4.5.jpg", "name": "", "value": "4.5"},
        {"image": "5.jpg", "name": "", "value": "5"},
        {"image": "5.5.jpg", "name": "", "value": "5.5"},
        {"image": "6.jpg", "name": "", "value": "6"},
        {"image": "6.5.jpg", "name": "", "value": "6.5"},
        {"image": "7.jpg", "name": "", "value": "7"},
        {"image": "7.5.jpg", "name": "", "value": "7.5"},
        {"image": "8.jpg", "name": "", "value": "8"},
        {"image": "8.5.jpg", "name": "", "value": "8.5"},
        {"image": "9.jpg", "name": "", "value": "9"}
      ],
      "attr": "rs"
  },
  "options_bl": {
      "image_base": "rs",
      "name": "Bracelet Length",
      "show": false,
      "option_name": "bl",
      "type": "select",
      "css": "rs",
      "image_postfix": "",
      "options": [
        {"value": "0", "show": false},
        {"image": "6.5.jpg", "name": "", "value": "6"},
        {"image": "7.25.jpg", "name": "", "value": "7"},
        {"image": "8.jpg", "name": "", "value": "8"}
      ],
      "attr": "bl"
  },
  "options_hmet": {
      "image_base": "metals6",
      "name": "Metal 1",
      "show": false,
      "css": "line1",
      "option_name": "hmet",
      "type": "select",
      "image_postfix": "",
      "options": [
        {"value": "0", "show": false},
        {"image": "s.jpg", "name": "Silver", "value": "S"},
        {"image": "10w.jpg", "name": "Gold", "value": "10W"},
        {"image": "10y.jpg", "name": "Gold", "value": "10Y"},
        {"image": "10r.jpg", "name": "Gold", "value": "10R"},
        {"image": "14w.jpg", "name": "Gold", "value": "14W"},
        {"image": "14y.jpg", "name": "Gold", "value": "14Y"},
        {"image": "14r.jpg", "name": "Gold", "value": "14R"}
      ]
  },
  "options_rmet": {
      "image_base": "metals6",
      "name": "Metal 2",
      "show": false,
      "css": "line1",
      "option_name": "rmet",
      "type": "select",
      "image_postfix": "",
      "options": [
        {"value": "0", "show": false},
        {"image": "s.jpg", "name": "Silver", "value": "S"},
        {"image": "10w.jpg", "name": "Gold", "value": "10W"},
        {"image": "10y.jpg", "name": "Gold", "value": "10Y"},
        {"image": "10r.jpg", "name": "Gold", "value": "10R"},
        {"image": "14w.jpg", "name": "Gold", "value": "14W"},
        {"image": "14y.jpg", "name": "Gold", "value": "14Y"},
        {"image": "14r.jpg", "name": "Gold", "value": "14R"}
      ]
  },
  "options_cross1": {
    "image_base": "cross",
    "name": "Add a Matching Style",
    "show": false,
    "option_name": "cross1",
    "type": "control",
    "css": "cross",
    "image_postfix": "",
    "options": [
      {"image": 1, "name": 0, "value": 1, "effect": [{"effect_attr": "show", "optionSet": ["rs2"], "effect_value": true, "if_attr": "type", "if_value": ["P","E","B"]}, {"effect_attr": "show", "optionSet": ["cross1"], "option": [0], "effect_value": true}]},
      {"image": 2, "name": 1, "value": 2, "effect": [{"effect_attr": "show", "optionSet": ["rs2"], "effect_value": true, "if_attr": "type", "if_value": ["P","E","B"]}, {"effect_attr": "show", "optionSet": ["cross1"], "option": [0], "effect_value": true}]},
      {"image": 0, "name": "", "value": 0, "show": false, "effect": [{"effect_attr": "show", "optionSet": ["rs2"], "effect_value": false}, {"effect_attr": "show", "optionSet": ["cross1"], "option": [0], "effect_value": false}]}
    ]
  },
  "options_rs2": {
      "image_base": "rs",
      "name": "Ring Size",
      "show": false,
      "option_name": "rs2",
      "type": "select",
      "css": "rs",
      "image_postfix": "",
      "options": [
        {"value": "0", "show": false},
        {"image": "4.jpg", "name": "", "value": "4"},
        {"image": "4.5.jpg", "name": "", "value": "4.5"},
        {"image": "5.jpg", "name": "", "value": "5"},
        {"image": "5.5.jpg", "name": "", "value": "5.5"},
        {"image": "6.jpg", "name": "", "value": "6"},
        {"image": "6.5.jpg", "name": "", "value": "6.5"},
        {"image": "7.jpg", "name": "", "value": "7"},
        {"image": "7.5.jpg", "name": "", "value": "7.5"},
        {"image": "8.jpg", "name": "", "value": "8"},
        {"image": "8.5.jpg", "name": "", "value": "8.5"},
        {"image": "9.jpg", "name": "", "value": "9"}
      ],
      "attr": "rs2"
  },
  "options_cross2": {
    "image_base": "cross",
    "name": "",
    "show": false,
    "option_name": "cross2",
    "type": "control",
    "css": "cross",
    "image_postfix": "",
    "options": [
      {"image": 1, "name": 2, "value": 1, "effect": [{"effect_attr": "show", "optionSet": ["cross2"], "option": [0], "effect_value": true}]},
      {"image": 2, "name": 3, "value": 2, "effect": [{"effect_attr": "show", "optionSet": ["cross2"], "option": [0], "effect_value": true}]},
      {"image": 0, "name": "", "value": 0, "show": false, "effect": [{"effect_attr": "show", "optionSet": ["cross2"], "option": [0], "effect_value": false}]}
    ]
  },
  "options_cross3": {
    "image_base": "cross",
    "name": "",
    "show": false,
    "option_name": "cross3",
    "type": "control",
    "css": "cross",
    "image_postfix": "",
    "options": [
      {"image": 1, "name": 4, "value": 1, "effect": [{"effect_attr": "show", "optionSet": ["bl2"], "effect_value": true, "if_attr": "type", "if_value": ["R","P","E"]}, {"effect_attr": "show", "optionSet": ["cross3"], "option": [0], "effect_value": true}]},
      {"image": 2, "name": 5, "value": 2, "effect": [{"effect_attr": "show", "optionSet": ["bl2"], "effect_value": false}, {"effect_attr": "show", "optionSet": ["cross3"], "option": [0], "effect_value": true}]},
      {"image": 0, "name": "", "value": 0, "show": false, "effect": [{"effect_attr": "show", "optionSet": ["bl2"], "effect_value": false}, {"effect_attr": "show", "optionSet": ["cross3"], "option": [0], "effect_value": false}]}
    ]
  },
  "options_bl2": {
      "image_base": "rs",
      "name": "Bracelet Length",
      "show": false,
      "option_name": "bl2",
      "type": "select",
      "css": "rs",
      "image_postfix": "",
      "options": [
        {"value": "0", "show": false},
        {"image": "6.5.jpg", "name": "", "value": "6"},
        {"image": "7.25.jpg", "name": "", "value": "7"},
        {"image": "8.jpg", "name": "", "value": "8"}
      ],
      "attr": "bl2"
  },
}


// WEBPACK FOOTER //
// ./src/config/kay-testC.js